// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hz-0";